module.exports = __webpack_public_path__ + "static/assets/c1e0c4baab39efea3b32998190cfda0a.png";